import ArrowIcon from '@assets/icons/arrow-up.svg?react'
import BatchPaymentIcon from '@assets/icons/batch-payment.svg?react'
import CrossIcon from '@assets/icons/cross.svg?react'
import ExchangeIcon from '@assets/icons/exchange.svg?react'
import QRCodeIcon from '@assets/icons/qr-code.svg?react'
import { MMButton } from '@components/WebComponents'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import type { ComponentType } from 'react'
import { Link } from 'react-router-dom'

import './PaymentActionButton.scss'

export type PaymentActionButtonType = 'deposit' | 'send' | 'exchange' | 'scanAndPay' | 'batchPayment'

export type PaymentActionButtonConfig = {
  type: PaymentActionButtonType
  path: string
  label: string
  icon: ComponentType
}

const paymentActionButtonRegistry: Record<PaymentActionButtonType, () => PaymentActionButtonConfig> = {
  deposit: () => ({
    type: 'deposit',
    path: paths.banking.deposit(),
    label: tr('FRONTEND.DASHBOARD.BUTTONS.DEPOSIT', 'Deposit'),
    icon: CrossIcon
  }),
  send: () => ({
    type: 'send',
    path: paths.banking.send(),
    label: tr('FRONTEND.DASHBOARD.BUTTON_SEND', 'Send'),
    icon: ArrowIcon
  }),
  exchange: () => ({
    type: 'exchange',
    path: paths.banking.exchange(),
    label: tr('FRONTEND.DASHBOARD.BUTTONS.EXCHANGE', 'Exchange'),
    icon: ExchangeIcon
  }),
  scanAndPay: () => ({
    type: 'scanAndPay',
    path: paths.scanAndPay(),
    label: tr('FRONTEND.DASHBOARD.BUTTONS.SCAN_AND_PAY', 'Scan & Pay'),
    icon: QRCodeIcon
  }),
  batchPayment: () => ({
    type: 'batchPayment',
    path: paths.banking.sendBatchPayment(),
    label: tr('FRONTEND.DASHBOARD.BUTTONS.BATCH_PAYMENT', 'Batch payment'),
    icon: BatchPaymentIcon
  })
}

interface PaymentActionButtonProps {
  type: PaymentActionButtonType
}

export const PaymentActionButton = ({ type }: PaymentActionButtonProps) => {
  const { path, label, icon } = paymentActionButtonRegistry[type]()

  return (
    <Link className='payment-action-button-link' to={path}>
      <div className='payment-action-button-wrapper'>
        <MMButton type='button' size='large' variant='square-elevated' collapsed collapsedIcon={icon} />
        <span>{label}</span>
      </div>
    </Link>
  )
}
